import { Button, ButtonProps } from 'antd'
import ChatIcon from '../ChatIcon'

import './ChatButton.style.less'

type Props = {
  onClick?: () => void
  chatCount?: number
  redPoint?: boolean
  isHidden?: boolean
  showIcon?: boolean
} & ButtonProps

function ChatButton(props: Props) {
  const {
    redPoint = false,
    chatCount = 0,
    isHidden = false,
    showIcon = true,
    ...buttonProps
  } = props
  const isDisplayCount = !!chatCount

  return (
    <Button
      {...buttonProps}
      className="wrap-comment-btn"
      hidden={isHidden}
      type="text"
      onClick={props.onClick}
    >
      {showIcon && <ChatIcon />}
      {isDisplayCount && <span>{chatCount}</span>}
      {redPoint && isDisplayCount && <div className="red-point" />}
    </Button>
  )
}

export default ChatButton
